import React from 'react';
import PropTypes from 'prop-types';
import Badge from '../badge';
import Countdown from '../countdown';

const GigBadges = (props) => {
    const badges = [],
        badgeMatrix = [
            [<Badge key={`${props.gigId}_badge_limited`} type="limited"/>, props.limitedEdition],
            [<Badge key={`${props.gigId}_badge_talent`} type="talent"/>, props.risingTalent],
            [<Badge key={`${props.gigId}_badge_high_completion`} className="high-completion" type="high_completion"/>, props.reliable],
            [<Badge key={`${props.gigId}_badge_featured`} type="featured"/>, props.featured],
            [<Badge key={`${props.gigId}_badge_choice`} type="choice"/>, props.qualityChoice],
            [<Badge key={`${props.gigId}_badge_now`} type="now" seller={props.sellerName}/>, props.availableNow]
        ],
        badge = badgeMatrix.find(([ badgeComponent, condition]) => condition); // eslint-disable-line no-unused-vars

    badge && badges.push(badge[0]);
    props.limitedEdition && badges.push(<Countdown key={`${props.gigId}_countdown`} deadline={props.limitedEditionDeadline}/>);
    props.pro && badges.push(<Badge key={`${props.gigId}_badge_pro`} type="pro"/>);

    return badges.length ? (<span className="gig-badge-container">{badges}</span>) : null;
};

GigBadges.propTypes = {
    featured: PropTypes.bool,
    limitedEdition: PropTypes.bool,
    limitedEditionDeadline: PropTypes.string,
    qualityChoice: PropTypes.bool,
    reliable: PropTypes.bool,
    availableNow: PropTypes.bool,
    risingTalent: PropTypes.bool,
    sellerName: PropTypes.string,
    pro: PropTypes.bool,
    gigId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};


export default GigBadges;



// WEBPACK FOOTER //
// ./src/shared/gig_badges/index.js